import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const Card = styled.li`
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor
      ? theme.colors[$backgroundColor]
      : themeGet('colors.white')};
  min-height: 260px;
  width: 100%;
  display: grid;
  grid-row: 1 / -1;
  grid-template-rows: subgrid;
  justify-content: center;
  border-radius: 0.375rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  &.columns-3 {
    border-radius: 0.625rem;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 15.4375rem;
  width: 100%;
  background-image: ${({ $image }) => `url(${$image})`};
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    height: 18rem;
  }
`;

export const Body = styled.div`
  display: grid;
  grid-row: 2 / 10;
  grid-template-rows: subgrid;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
  width: 100%;
  gap: 1.5rem;
`;

export const TextWrapper = styled.div`
  display: grid;
  grid-row: 1 / 10;
  grid-template-rows: subgrid;
  flex: 1 1 auto;
  padding: 1.5rem;
  width: 100%;
  text-align: ${({ $textAlignment }) => $textAlignment || 'left'};
`;

export const BodyCopy = styled.p``;

export const LegalCopy = styled.p`
  font-size: 0.75rem;
  margin-top: 0.5rem;
`;

export const StyledCtas = styled(Ctas)`
  margin: 1.5rem;
  gap: 2rem;
  flex-direction: column;
  place-items: start;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    place-items: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: row;
  }
`;

export const Heading = styled.h3`
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 130%;
`;
